import { gql } from '@apollo/client';

import { CORE_ASSET_FIELDS } from 'app/src/components/Assets/queries';

export const OFFER_FIELDS = gql`
  fragment OfferFields on Offer {
    id
    saleAsset { id }
    original { id }
    prior { id }
    price
    soldPrice
    validatedMethod
    validatedAt
    isIf
    counterPrice
    result
  }
`;

export const SALE_ASSET_CORE_FIELDS = gql`
  fragment SaleAssetCoreFields on SaleAsset {
    id
    status
    correctedLotNumber
    reserveAbsolute
    reservePrice
    sellerNet
    sellerAchInstRec
    sellerAchOn
    commissionPaidOn
    bosOn
    pickedUpOn
    releaseHold
    release
    invoiceSentOn
    invoiceNumber
    invoiceAmount
    buyerWireAmount
    buyerWireOn
    incomingWireTitle
    notes
  }
`;

const SALE_ASSET_FIELDS = gql`
  ${SALE_ASSET_CORE_FIELDS}
  ${OFFER_FIELDS}
  fragment SaleAssetFields on SaleAsset {
    ...SaleAssetCoreFields
    sale { id, name}
    asset {
      ${CORE_ASSET_FIELDS}
      seller { id, name }
      location { id, street, city, state }
      street, city, state
      latestTitleLog { status }
    }
    activeOffer {
      ...OfferFields
    }
    customNotificationsCount
    sellerFees
  }
`;

export const SALE_ASSETS = gql`
  ${SALE_ASSET_FIELDS}
  query SaleAssets(
    $saleId: ID
    $sellerId: ID
  ) {
    saleAssets(
      saleId: $saleId
      sellerId: $sellerId
    ) {
      ...SaleAssetFields
    }
  }
`;

export const SALE_ASSET_UPDATED = gql`
  ${SALE_ASSET_FIELDS}
  subscription SaleAssetUpdated (
    $saleId: ID
    $sellerId: ID
  ) {
    saleAssetUpdated(
      saleId: $saleId
      sellerId: $sellerId
    ) {
      saleAsset {
        ...SaleAssetFields
      }
    }
  }
`;

export const UPDATE_SALE_ASSET = gql`
  ${SALE_ASSET_CORE_FIELDS}
  mutation UpdateSaleAsset(
    $id: ID!
    $reservePrice: Decimal
    $reserveAbsolute: Boolean
    $assetAttributes: AssetInput
    $offerAttributes: OfferInput
  ) {
    updateSaleAsset(
      id: $id
      reservePrice: $reservePrice
      reserveAbsolute: $reserveAbsolute
      assetAttributes: $assetAttributes
      offerAttributes: $offerAttributes
    ) {
      saleAsset {
        ...SaleAssetCoreFields
      }
    }
  }
`;
